import { createGlobalStyle } from "styled-components";

const Styles = createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-size: 16px;
    /* font-family: "Inter", sans-serif; */
    font-family: "Quicksand", sans-serif;
  }
  a{
    text-decoration: none;
  }
  li,ul{
    list-style: none;
  }
  html, body{
    max-width: 100vw;
    overflow-x: hidden;
    background-color:#e6e6e6;
  }

  /* h1,h2,h3,h4{
    font-family: "Inter", sans-serif;
  } */

  #root{
    --main-green: #008B47;
    --light-green: #39FF14;

    --main-blue: #004da2;
    --dark-blue: #013876;
    --darkest-blue: #001d3f;
    --eletric-blue: #007BFF;

    --main-height: calc(100vh - (115.54px + 230px));
  }
`;
export default Styles;
